import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

function SvgComponent(props) {
    return (
        <Svg width={62} height={81} viewBox="0 0 62 81" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <Path
                d="M30.263.75c9.447 0 17.214 3.209 22.617 8.928 5.398 5.714 8.37 13.866 8.37 23.635 0 17.5-11.106 37.522-28.74 46.85l-.165.087H6.768l-.323-1.428c12.87-6.12 24.624-15.431 30.686-25.106-3.065 1.798-6.734 2.86-10.767 2.86C12.991 56.575.75 45.458.75 29.825.75 14.547 11.794.75 30.263.75zm.948 17.036c-3.085 0-5.813 1.097-7.768 3.045-1.951 1.946-3.177 4.787-3.177 8.36 0 3.63 1.228 6.497 3.18 8.454 1.953 1.96 4.68 3.056 7.765 3.056 3.14 0 5.865-1.098 7.804-3.054 1.936-1.956 3.14-4.822 3.14-8.456 0-3.578-1.202-6.418-3.14-8.362-1.938-1.945-4.664-3.043-7.804-3.043z"
                fill={designSystem.colors.neutral900}
                stroke={ds.colorValue.icon.brand}
                strokeWidth={1.5}
            />
        </Svg>
    );
}

export default SvgComponent;
